export const papelHigienicoProducts = [
  {
    id: 1,
    name: 'Noble 22 m',
    image: 'https://public.readdy.ai/ai/img_res/3caecc3e-5cff-4742-ae58-8c0cfa3882ea.png',
    unitsPerPack: 48,
    packagingType: 'Manga',
    unitPrice: 185,
    packPrice: 8900,
    palletPrice: null,
  },
  {
    id: 2,
    name: 'Swan 22 m',
    image: 'https://public.readdy.ai/ai/img_res/d1f48aeb-cb53-45b4-8cce-bd457424b07a.png',
    unitsPerPack: 48,
    packagingType: 'Manga',
    unitPrice: 185,
    packPrice: 8900,
    palletPrice: null,
  },
  {
    id: 3,
    name: 'Elite 50 m hoja doble',
    image: 'https://public.readdy.ai/ai/img_res/7b4f9bc7-a7ab-460a-b3b2-2dc98abf0997.png',
    unitsPerPack: 32,
    packagingType: 'Manga',
    unitPrice: 625,
    packPrice: 20000,
    palletPrice: null,
  },
  {
    id: 4,
    name: 'Abolengo 100 m',
    image: 'https://public.readdy.ai/ai/img_res/cbdd349b-069a-4dae-8d03-674e338c0a06.png',
    unitsPerPack: 6,
    packagingType: 'Manga',
    unitPrice: 2333,
    packPrice: 14000,
    palletPrice: null,
  },
  {
    id: 5,
    name: 'Nova ultra 70 m',
    image: 'https://public.readdy.ai/ai/img_res/8b279284-463d-447e-be71-63943a4638ce.png',
    unitsPerPack: 8,
    packagingType: 'Manga',
    unitPrice: 625,
    packPrice: 5000,
    palletPrice: null,
  },
];
